
export interface DemandGWForH3R4
{
    h3r4_id: string
    proportional_demand: number
    demand_GW: number
}

export type DemandByH3R4Cell = Record<string, DemandGWForH3R4>

export const STORAGE_TYPES = [
    "battery",
    "hydro_pumped_storage",
] as const
export const POWER_TYPES = [
    "wind",
    "solar",
    "gas",
    "nuclear",
    "hydro_river",
    ...STORAGE_TYPES,
] as const
export type StorageType = (typeof STORAGE_TYPES)[number]
export type PowerType = (typeof POWER_TYPES)[number]
export type ValueByStorageType<V> = Record<StorageType, V>
export type ValueByPowerType<V> = Record<PowerType, V>
export type ValueByPowerStorageType<VPower, VStore> = ValueByPowerType<VPower> & ValueByStorageType<VStore>

interface MWGenCap {
    generated_MW: number
    capacity_MW: number
}
interface MWhStore {
    stored_MWh: number
    store_capacity_MWh: number
}
export type MWGenCapStoreForH3R4 = {
    h3r4_id: string
    total_capacity_MW: number
    total_generated_MW: {
        primary: number
        storage: number
    }
} & ValueByPowerStorageType<MWGenCap, MWhStore>


export interface ModelStateAtTimepointV0
{
    timestamp_ms: number
    timestamp_index: number
    demand_GW: number
    generated_GW: {
        primary: number
        storage: number
    }
    generated_GW_by_type: ValueByPowerType<number>
    capacity_GW_by_type: ValueByPowerType<number>
    stored_GWh_by_type: ValueByStorageType<number>
    store_capacity_by_type: ValueByStorageType<number>
}

export interface IGameScore
{
    building_cost: number
    shortage_TWh: number
    excess_TWh: number
    running_cost: number
    resilience_score: number
    total_score: number
}
